import { Button } from '@mui/material'
import PropTypes from 'prop-types'
import { BODY_FONT, GAME } from './gamey.js'

// A chunky button with a solid edge underneath that sinks when pressed, like a real key.
const TONES = {
    primary: {
        bg: GAME.green,
        fg: GAME.white,
        edge: GAME.greenEdge,
        border: 'transparent'
    },
    secondary: {
        bg: GAME.white,
        fg: GAME.green,
        edge: GAME.lineStrong,
        border: GAME.lineStrong
    },
    amber: {
        bg: GAME.amber,
        fg: GAME.ink,
        edge: GAME.amberEdge,
        border: 'transparent'
    },
    // On an amber band, where the light edge would vanish.
    ink: { bg: 'transparent', fg: GAME.ink, edge: GAME.ink, border: GAME.ink }
}

const pressSx = (tone = 'primary') => {
    const { bg, fg, edge, border } = TONES[tone]
    return {
        bgcolor: bg,
        color: fg,
        border: `2px solid ${border}`,
        borderRadius: '16px',
        boxShadow: `0 5px 0 ${edge}`,
        fontFamily: BODY_FONT,
        fontWeight: 900,
        fontSize: '1.0625rem',
        textTransform: 'none',
        letterSpacing: 0,
        minHeight: 52,
        px: 3,
        py: 1.25,
        transition: 'transform 80ms ease, box-shadow 80ms ease',
        '&:hover': {
            bgcolor: bg,
            filter: 'brightness(1.05)',
            boxShadow: `0 5px 0 ${edge}`
        },
        '&:active': {
            transform: 'translateY(4px)',
            boxShadow: `0 1px 0 ${edge}`
        },
        '&:focus-visible': {
            outline: `3px solid ${GAME.sky}`,
            outlineOffset: 3
        },
        '&.Mui-disabled': {
            bgcolor: GAME.line,
            color: '#6B7A86',
            border: `2px solid ${GAME.line}`,
            boxShadow: `0 5px 0 ${GAME.lineStrong}`
        },
        '@media (prefers-reduced-motion: reduce)': {
            transition: 'none',
            '&:active': { transform: 'none' }
        }
    }
}

const GameButton = ({ tone = 'primary', sx, ...props }) => (
    <Button
        data-press-tone={tone}
        disableElevation
        disableRipple
        sx={{ ...pressSx(tone), ...sx }}
        variant="contained"
        {...props}
    />
)

GameButton.propTypes = {
    tone: PropTypes.oneOf(Object.keys(TONES)),
    sx: PropTypes.object
}

export default GameButton
